module.exports = __webpack_public_path__ + "img/bid-success.1c4901f7.png";